import React, { useEffect, useRef, useState } from 'react'
// import Progress from './Progress'
import { useDispatch, useSelector } from 'react-redux';
import inputErrors from '../../helpers/validation'
import { saveProfile } from '../../../redux/reducers/profileSlice';
import Loader from '../../helpers/Loader';
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import InfoIcon from '@mui/icons-material/Info';
import dayjs from 'dayjs';
import Switch from "react-switch";
import { ReactComponent as Illus1 } from '../../../images/hand.svg'
// import { snackbarContext } from '../../helpers/Snakbar';
import './countdownform.css'


const COUNTDOWN_DETAILS_FIELDS = [
    "blessingMessage",
];

const CountdownDetail = ({ onBack, onNext }) => {
    // const setStateSnackbarContext = React.useContext(snackbarContext);
     const timeoutRef = useRef(null);
    const formRef = useRef(null);
    const dispatch = useDispatch()
    const { user } = useSelector((state) => state.auth)
    const [showWeddingDateWarning, setShowWeddingDateWarning] = useState(false);
const [showCountdownDateWarning, setShowCountdownDateWarning] = useState(false);
    const { weddingData: profileData, loading } = useSelector((state) => state.profile)
    const [values, setValues] = useState({
        blessingMessage: "",
        weddingDate: "",
        countDownDate: "",
    })
      const [animate, setAnimate] = useState({
        days: false,
        hours: false,
        minutes: false,
        seconds: false,
      });
    const [isSubmitting, setSubmitting] = useState(false);
    const [errors, setErrors] = useState({})
    const [showCountdown, setShowCountdown] = useState(false);
    const handleChange = (event) => {
        setValues({
            ...values,
            [event.target.name]: event.target.value
        });

          if (event.target.name === "weddingDate") {
    setShowWeddingDateWarning(false);
  }

  if (event.target.name === "countDownDate") {
    setShowCountdownDateWarning(false);
  }
    }


const calculateTimeLeft = () => {
  if (!values.countDownDate) {
    return {
      days: "00",
      hours: "00",
      minutes: "00",
      seconds: "00",
    };
  }

  const difference =
    dayjs(values.countDownDate).endOf("day").valueOf() - Date.now();

  if (difference <= 0) {
    return {
      days: "00",
      hours: "00",
      minutes: "00",
      seconds: "00",
    };
  }

  return {
    days: String(Math.floor(difference / (1000 * 60 * 60 * 24))).padStart(2, "0"),
    hours: String(Math.floor((difference / (1000 * 60 * 60)) % 24)).padStart(2, "0"),
    minutes: String(Math.floor((difference / (1000 * 60)) % 60)).padStart(2, "0"),
    seconds: String(Math.floor((difference / 1000) % 60)).padStart(2, "0"),
  };
};

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft()); 


const renderTrialDateWarning = (selectedDate) => {
  if (!selectedDate || !user?.demoExpiryTime) {
    return null;
  }

  const trialExpiry = new Date(user.demoExpiryTime);
  const selected = new Date(selectedDate);

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
    });
  };

  return (
    <div className="trial-date-warning">
      <div className="trial-date-warning-icon">
        ⓘ
      </div>

      <div className="trial-date-warning-content">

        <div className="trial-date-warning-title">
          This date is within the trial period.
        </div>

        <div className="trial-date-warning-text">
          Your free trial ends on{" "}
          <strong>{formatDate(trialExpiry)}</strong>.
        </div>

        <div className="trial-date-warning-text">
          To use <strong>{formatDate(selected)}</strong>, upgrade your invite.
        </div>

        <div className="trial-date-warning-hint">
          You can continue your trial by choosing a date after{" "}
          {formatDate(trialExpiry)}.
        </div>

      </div>
    </div>
  );
};

useEffect(() => {
  // Update immediately when date changes
  setTimeLeft(calculateTimeLeft());

  const timer = setInterval(() => {
    setTimeLeft((prev) => {
      const newTime = calculateTimeLeft();

      setAnimate({
        days: newTime.days !== prev.days,
        hours: newTime.hours !== prev.hours,
        minutes: newTime.minutes !== prev.minutes,
        seconds: newTime.seconds !== prev.seconds,
      });

      clearTimeout(timeoutRef.current);

      timeoutRef.current = setTimeout(() => {
        setAnimate({
          days: false,
          hours: false,
          minutes: false,
          seconds: false,
        });
      }, 250);

      return newTime;
    });
  }, 1000);

  return () => {
    clearInterval(timer);
    clearTimeout(timeoutRef.current);
  };
}, [values.countDownDate]);


  const handleSubmit = (e) => {
        e.preventDefault()
       const validationErrors = inputErrors(
               values,
               COUNTDOWN_DETAILS_FIELDS
           );
         


        // Ignore countdown validation if switch is OFF
        if (!showCountdown) {
            delete validationErrors.countDownDate;
        }

        // if(!values.weddingDate ){
        //    validationErrors.weddingDate="Wedding date is required "
        // }else if(user?.demoVersion && values.weddingDate < getCurrentDate()){
        //      validationErrors.weddingDate = `Invalid date. Value must be ${getCurrentDate()} or later.`
        // }else if(user?.demoVersion && values.weddingDate < user.demoExpiryTime){
        //       setShowWeddingDateWarning(true); return;  
        // }

        if (user?.demoVersion) {
    if (!values.weddingDate) {
        validationErrors.weddingDate = "Wedding date is required";
    } else if (values.weddingDate < getCurrentDate()) {
        validationErrors.weddingDate = `Invalid date. Value must be ${getCurrentDate()} or later.`;
    } else if (values.weddingDate < user.demoExpiryTime) {
        setShowWeddingDateWarning(true);
        return;
    }
}

        

        if (showCountdown) {

            if (values.countDownDate < getCurrentDate()) {

                validationErrors.countDownDate =
                    `Invalid date. Value must be ${getCurrentDate()} or later.`;

            } 
            
            else if (user?.demoVersion && values.countDownDate < user.demoExpiryTime) {
              setShowCountdownDateWarning(true); return;  
               
            }
        }
        setErrors(validationErrors)
        setSubmitting(true)
    }

    function getCurrentDate() {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    const formatDate = (inputDate) => {
        const date = dayjs(inputDate);
        const formattedDate = date.format('DD MMMM YYYY');
        return formattedDate
    };

     const formatDateWithDots = (inputDate) => {
  if (!inputDate) return "";
  return dayjs(inputDate).format("DD.MM.YYYY");
};


 


    const redirectToWhatsApp = () => {
        const phoneNumber = "+919326150846";
        const message = encodeURIComponent(`Hello Aamantran Team, I would like to update my wedding date. My user code is:${user && user.userCode} `);
        window.location.href = `https://wa.me/${phoneNumber}?text=${message}`;
    };



    useEffect(() => {
        if (isSubmitting) {
            const noErrors = Object.keys(errors).length === 0;
            if (noErrors) {
                savedata()
            } else {
                formRef.current.scrollIntoView({ behavior: "smooth" });
            }

        }
    }, [isSubmitting, errors])

    const savedata = () => {
        setSubmitting(false)
        dispatch(saveProfile({ values, onNext }))
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    useEffect(() => {
        setValues({ ...profileData })

        setShowCountdown(!!profileData?.countDownDate);
    }, [profileData])

    const handleCountdownToggle = (checked) => {

        setShowCountdown(checked);

        // User turned OFF the switch
        if (!checked) {
            setValues(prev => ({
                ...prev,
                countDownDate: ""
            }));
        }
    };

    if (loading) {
        return <Loader />
    }


    return (
        <>
            {/* <Progress activeStep={1} demoVersion={user && user.demoVersion} /> */}
            <div className="form-screen">
                <div className="container mb-3">
                    <div className="row d-flex row-containers  mx-2">
                        <div className="col-lg-6 col-md-11 form-container">
                            <h3 className='form-heading'> Coutdown Details</h3>
                            <form className='form-div' onSubmit={handleSubmit} ref={formRef} >
                                {user && user.demoVersion ? <>
                                    <div className={errors.weddingDate ? "date-container date-error" : "date-container"}>
                                        <label >Wedding Date <span style={{ color: "red" }}> *</span> </label>
                                        <input
                                            type="date"
                                            name='weddingDate'
                                            value={values.weddingDate}
                                            onChange={handleChange}
                                            className='wedding-date-input'
                                        />
                                    </div>
                                    <div className='error-wedding-div'>  {errors.weddingDate && (<small className="error-msg-wedding">{errors.weddingDate}</small>)}</div>
                                     {showWeddingDateWarning && renderTrialDateWarning(values.weddingDate)}
                                </> :
                                    <>
                                        <div className="date-container">
                                            <label >Wedding Date
                                                <OverlayTrigger placement="auto" overlay={
                                                    <Tooltip id="tooltip-group">
                                                        <span>
                                                            Wedding Date is fixed for security and misuse prevention.<br />Need a Change? Just reach out!
                                                        </span>
                                                    </Tooltip>
                                                }>
                                                    <InfoIcon className='date-tooltip-icon' />
                                                </OverlayTrigger>
                                            </label>
                                            <input
                                                type="text"
                                                name='weddingDate'
                                                value={user && formatDate(user.weddingDate)}
                                                className='wedding-date-input wedding-date-disabled'
                                                disabled
                                            />
                                            <button className='weddate-buton' type="button" onClick={() => redirectToWhatsApp()}><i className="fa-brands fa-whatsapp" ></i> Need a Change?</button>
                                        </div>
                                    </>
                                }
                                <div className="blessing-message-form-conatiner">
                                     <label className={errors.blessingMessage ? 'blessing-label blessing-label-error' : "blessing-label"} >Opening Message (optional)</label>
                                <textarea
                                    name="blessingMessage"
                                    value={values.blessingMessage}
                                    onChange={handleChange}
                                    className={errors.blessingMessage ? "blessing-input-feild blessing-input-error" : "blessing-input-feild"}
                                    placeholder='Eg: With blessings of our guiding angels, Grandfather’s Name & Grandmother’s Name, we cordially invite you.'
                                />
                               
                                </div>
                                  {errors.blessingMessage && (<div className='error-wedding-div'> <small className="error-msg-wedding">{errors.blessingMessage}</small></div>)}
                               
                                

                                <div className={`condition-form-div ${showCountdown ? "" : "countdown-condital-div"}`}>
                                    <label> Show countdown? (optional) </label>
                                    <Switch
                                        checked={showCountdown}
                                        onChange={handleCountdownToggle}
                                        onColor="#1636ff"
                                        offColor="#c9c9c9"
                                        checkedIcon={false}
                                        uncheckedIcon={false}
                                        handleDiameter={22}
                                        height={26}
                                        width={46}
                                    />
                                </div>

                                {showCountdown && (<><div className="date-condition-div">
                                    <label> <span>Countdown End Date</span></label>
                                    <input type="date" className='countodown-date-container' name='countDownDate' value={values.countDownDate ? values.countDownDate : getCurrentDate()} onChange={handleChange} />

                                </div>
                                    <small> </small>
                                    <div className='error-wedding-div'>  {errors.countDownDate && (<small className="error-msg-wedding">{errors.countDownDate}</small>)}</div>
                                      {showCountdownDateWarning && renderTrialDateWarning(values.countDownDate)}                       
                                </>
                                )}

                                <div className='form-double-buttons'>
                                    <button type='button' onClick={onBack} >Back</button>
                                    <button type='submit'>Save</button>
                                </div>

                            </form>
                        </div>
                         <div className="col-lg-5 col-md-12 preview-container-bg  ">
                            <div className={`second-form-preview-container ${values?.theme || ''}`}>
                                 {/* <img src="illus1.png" alt="hand-illustaruion"  /> */}
                                  <Illus1 className="save-date-preview-illustration" />
                                  <h1>Our Forever Begins</h1>
                                  {user?.demoVersion ?   <h3>{formatDateWithDots(values.weddingDate)}</h3>:   <h3>{formatDateWithDots(user?.weddingDate)}</h3> }
                                 
                                   <span className='opening-message-preview'>{values.blessingMessage}</span>

                                   {showCountdown && ( <>
                                     <h1>Counting down to Forever</h1>
                                      <div className="preview-countdown-container">
                                        <div className="preview-countdown-item">
                                          <div className="preview-countdown-box">
                                             <span className={animate.days ? "flip-number" : ""}>
                                                   {timeLeft.days}
                                                       </span>           
                                          </div>
                                             <p>Days</p>
                                        </div>

                                           <div className="preview-countdown-item">
                                          <div className="preview-countdown-box">
                                             <span className={animate.hours ? "flip-number" : ""}>
                                                   {timeLeft.hours}
                                                       </span>           
                                          </div>
                                             <p>Hours</p>
                                        </div>

                                          <div className="preview-countdown-item">
                                          <div className="preview-countdown-box">
                                             <span className={animate.minutes ? "flip-number" : ""}>
                                                   {timeLeft.minutes}
                                                       </span>           
                                          </div>
                                             <p>Minutes</p>
                                        </div>
                                           <div className="preview-countdown-item">
                                          <div className="preview-countdown-box">
                                             <span className={animate.seconds ? "flip-number" : ""}>
                                                   {timeLeft.seconds}
                                                       </span>           
                                          </div>
                                             <p>Seconds</p>
                                        </div>
                                      </div>
                                   </>)}
                                     
                            </div>
                         </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CountdownDetail